import { EmailState, selectAll } from './email.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const emailState = createFeatureSelector<EmailState>( "email" );

export const emailPersonal = createSelector(
	emailState,
	state => state.personal
);

export const emailDelegados = createSelector(
    emailState,
    selectAll
);

export const emailReady = createSelector(
    emailState,
    state => state.ready
);

export const emailDelegadosFavs = createSelector(
	emailDelegados,
	delegados => delegados != null && delegados.length > 0? delegados.filter( delegado => delegado.marked ): null
);